import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=4fc1859e&scoped=true"
import script from "./navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=4fc1859e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1859e",
  null
  
)

export default component.exports